import { useEffect, useState } from 'react';

export function useCountdown(initialSeconds: number): number {
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    const id = window.setInterval(() => {
      setSeconds((prev) => (prev <= 1 ? initialSeconds : prev - 1));
    }, 1000);
    return () => window.clearInterval(id);
  }, [initialSeconds]);

  return seconds;
}
